var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideButton ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("repairEstimate.accept")) + " ")]) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.currentStep.title,
      "subtitle": _vm.currentStep.subtitle,
      "loading": _vm.currentStep.loading,
      "rightLoading": _vm.currentStep.loading,
      "hideLeft": _vm.currentStep.hideBack
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "close": _vm.close,
      "leftClick": _vm.currentStep.back,
      "rightClick": _vm.currentStep.next
    }
  }, [_c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateAcceptSteps.START
    }
  }), _c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateAcceptSteps.SEND_MAIL
    }
  }, [_vm.RepairEstimateAcceptSteps.SEND_MAIL ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_REPAIR_ESTIMATE_ACCEPT_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.value.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.value.seller ? [_vm.value.seller.email] : [],
      "refs": _vm.refs
    }
  }) : _vm._e()], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateAcceptSteps.SUCCESS
    }
  }, [_c('v-img', {
    staticClass: "mt-5 mb-5",
    attrs: {
      "align": "center",
      "justify": "center",
      "contain": "",
      "max-height": "200px",
      "src": require("@/assets/undraw/undraw_add_files_re_v09g.svg")
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }